import { render, staticRenderFns } from "./CarisSelect.vue?vue&type=template&id=55d5e3a2&scoped=true&"
import script from "./CarisSelect.vue?vue&type=script&lang=js&"
export * from "./CarisSelect.vue?vue&type=script&lang=js&"
import style0 from "./CarisSelect.vue?vue&type=style&index=0&id=55d5e3a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d5e3a2",
  null
  
)

export default component.exports